module.exports = __webpack_public_path__ + "img/ic_services_beachaccess.0d9926b5.svg";